<template>
  <wui-card
    state="text"
    shadow="overflow"
  >
    <wui-list class="text-nowrap">
      <wui-list-item
        icon="eyeM"
        @click="emit('view-avatar')"
      >
        {{ $t('common.viewAvatar') }}
      </wui-list-item>

      <wui-list-item
        icon="downloadM"
        @click="emit('upload-file')"
      >
        {{ $t('common.uploadFile') }}
      </wui-list-item>

      <template #footer>
        <wui-list-item
          icon="trashM"
          variant="negative"
          @click="emit('remove-avatar')"
        >
          {{ $t('common.removeAvatar') }}
        </wui-list-item>
      </template>
    </wui-list>
  </wui-card>
</template>

<script setup lang="ts">
import { WuiCard, WuiList, WuiListItem } from '@wui/common-library'

const emit = defineEmits<{
  (e: 'view-avatar'): void
  (e: 'upload-file'): void
  (e: 'remove-avatar'): void
}>()
</script>
